<template>
  <footer class="footer">
    <div class="columns">
      <div class="column">
        <h2 class="subtitle">Links</h2>
        <ul>
          <li><router-link to='/about'>About</router-link></li>
          <li><router-link to='/about'>Privacy</router-link></li>
        </ul>
      </div>
    </div>
    <div class="columns">
      <div class="column has-text-right has-text-left-mobile">
        <ul>
          <li class="is-family-monospace ">Find your kink. :)</li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
};
</script>
<style>
</style>